import { BenefitDTOBenefitEnum } from 'probonio-shared-ui/api';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { BenefitPaper } from '../../component/benefitTabs/BenefitPaper';
import { getBenefitIcon } from '../../module/benefits/BenefitIcon';

import BenefitSubPage from '../../module/benefits/BenefitSubPage';
import ITLeasingConnectPanel from '../../module/benefits/itLeasing/ITLeasingConnectPanel';
import { AuthorizedLayout } from '../../module/navigation/AuthorizedLayout';

const ITLeasingConnectPage: React.FC = () => {
  const { t } = useTranslation('benefitsModule');
  const navigate = useNavigate();

  const handleConnected = useCallback(() => {
    navigate('/benefits/it_leasing/settings');
  }, [navigate]);

  return (
    <AuthorizedLayout title={t('IT_LEASING.settings.title')} breadcrumbs={[{ title: t('IT_LEASING.title'), to: '/benefits/it_leasing' }]}>
      <BenefitSubPage
        icon={getBenefitIcon(BenefitDTOBenefitEnum.ItLeasing)}
        title={t('IT_LEASING.title')}
        subTitle={t('IT_LEASING.settings.title')}
      >
        <BenefitPaper sx={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
          <ITLeasingConnectPanel onConnected={handleConnected} />
        </BenefitPaper>
      </BenefitSubPage>
    </AuthorizedLayout>
  );
};

export default ITLeasingConnectPage;
